import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollTop (): JSX.Element | null {
  let { pathname } = useLocation()

  useEffect(() => {
    document.getElementById('scrollTop')?.scrollIntoView()
  }, [ pathname ])

  return null
}
